// Internationalization support
// Import all translation files
import sharedEn from './translations/shared-en.json';
import sharedZh from './translations/shared-zh.json';
import deadpanEn from './translations/deadpan/en.json';
import deadpanZh from './translations/deadpan/zh.json';
import deadpanItemsEn from './translations/deadpan/items-en.json';
import deadpanItemsZh from './translations/deadpan/items-zh.json';
import undercoverEn from './translations/undercover/en.json';
import undercoverZh from './translations/undercover/zh.json';
import bombRelayEn from './translations/bombRelay/en.json';
import bombRelayZh from './translations/bombRelay/zh.json';
import pensieveGameEn from './translations/pensieveGame/en.json';
import pensieveGameZh from './translations/pensieveGame/zh.json';
import similarMindsEn from './translations/similarMinds/en.json';
import similarMindsZh from './translations/similarMinds/zh.json';
import aceAttorneyEn from './translations/aceAttorney/en.json';
import aceAttorneyZh from './translations/aceAttorney/zh.json';
import gameTheoryWheelEn from './translations/gameTheoryWheel/en.json';
import gameTheoryWheelZh from './translations/gameTheoryWheel/zh.json';
import standApartEn from './translations/standApart/en.json';
import standApartZh from './translations/standApart/zh.json';
import schrodingerCrocEn from './translations/schrodingerCroc/en.json';
import schrodingerCrocZh from './translations/schrodingerCroc/zh.json';
export const DEFAULT_PENSIEVE_LEVEL_RANGE = { min: 0, max: 3 };
export function normalizePensieveLevelRange(range) {
    if (range.min <= range.max) {
        return { min: range.min, max: range.max };
    }
    return { min: range.max, max: range.min };
}
const translationsEn = {
    ...sharedEn,
    games: {
        deadpan: {
            ...deadpanEn,
            ...deadpanItemsEn,
        },
        undercover: undercoverEn,
        bombRelay: bombRelayEn,
        pensieve: pensieveGameEn,
        similarMinds: similarMindsEn,
        aceAttorney: aceAttorneyEn,
        gameTheoryWheel: gameTheoryWheelEn,
        standApart: standApartEn,
        schrodingerCroc: schrodingerCrocEn,
    },
};
const translationsZh = {
    ...sharedZh,
    games: {
        deadpan: {
            ...deadpanZh,
            ...deadpanItemsZh,
        },
        undercover: undercoverZh,
        bombRelay: bombRelayZh,
        pensieve: pensieveGameZh,
        similarMinds: similarMindsZh,
        aceAttorney: aceAttorneyZh,
        gameTheoryWheel: gameTheoryWheelZh,
        standApart: standApartZh,
        schrodingerCroc: schrodingerCrocZh,
    },
};
const translations = {
    en: translationsEn,
    zh: translationsZh,
};
const STORAGE_KEY = 'deadpan:language';
function getStoredLanguage() {
    if (typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined') {
        try {
            const stored = window.sessionStorage.getItem(STORAGE_KEY);
            if (stored === 'en' || stored === 'zh')
                return stored;
        }
        catch { }
    }
    return 'zh';
}
let currentLanguage = getStoredLanguage();
export function setLanguage(lang) {
    currentLanguage = lang;
    if (typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined') {
        try {
            window.sessionStorage.setItem(STORAGE_KEY, lang);
            // Dispatch custom event to notify components of language change
            window.dispatchEvent(new Event('languagechange'));
        }
        catch { }
    }
}
export function getLanguage() {
    return currentLanguage;
}
export function getTranslations() {
    return translations[currentLanguage];
}
export function getTranslationsForLanguage(lang) {
    return translations[lang];
}
// Helper function to replace placeholders in strings
export function formatString(template, values) {
    return template.replace(/\{(\w+)\}/g, (match, key) => values[key] || match);
}
// Helper function to translate error messages from server
export function translateError(errorMessage) {
    const t = getTranslations();
    const errorMap = {
        'Player name is required': 'playerNameRequired',
        'Failed to generate room code. Please try again.': 'failedToGenerateRoomCode',
        'Failed to create room': 'failedToCreateRoom',
        'You are not in a room': 'notInRoom',
        'Room not found': 'roomNotFound',
        'Only the host can start the game': 'onlyHostCanStart',
        'Game has already started': 'gameAlreadyStarted',
        'Cannot start game. Need at least 3 players and all must be connected.': 'cannotStartGame',
        'Failed to join room. Room may be full or you may already be in it.': 'failedToJoinRoom',
        'A player with this name is already in the room': 'duplicatePlayerName',
    };
    const errorKey = errorMap[errorMessage];
    if (errorKey) {
        return t.ui.errors[errorKey];
    }
    // If no translation found, return original message
    return errorMessage;
}
//# sourceMappingURL=i18n.js.map